import React from 'react'
import classnames from "classnames"
import {CircleFilled16} from "@carbon/icons-react"
import "./Feedback.scss"

const Feedback = ({classNames, feedback, flex}) => {
  return  <span className={classnames("feedback", classNames, {flex}, feedback)}>
             <CircleFilled16 />
            </span>
}

export default Feedback